export default [
  {
    path: '/post-replies',
    name: 'post-replies',
    component: () => import('@/views/postReplies/PostReplies.vue'),
    meta: {
      clinicianBlocked: true,
      protected: true,
      pageTitle: 'Post replies',
      breadcrumb: [
        {
          text: 'Post Replies',
          active: true,
        },
      ],
    },
  },
  {
    path: '/post-reply-search',
    name: 'post-reply-search',
    component: () => import('@/views/postReplies/PostReplySearch.vue'),
    meta: {
      clinicianBlocked: true,
      protected: true,
      pageTitle: 'Post replies',
      breadcrumb: [
        {
          text: 'Post Replies',
          active: true,
        },
      ],
    },
  },
  {
    path: '/post-replies-fail',
    name: 'post-replies-fail',
    component: () => import('@/views/postReplyFailure/PostReplyFail.vue'),
    meta: {
      clinicianBlocked: true,
      protected: true,
      pageTitle: 'Failed post replies',
      breadcrumb: [
        {
          text: 'Failed Post Replies',
          active: true,
        },
      ],
    },
  },
  {
    path: '/post-replies-fail/details/:id',
    name: 'failed-reply-details',
    component: () => import('@/views/postReplyFailure/details/PostReplyFailDetails.vue'),
    meta: {
      clinicianBlocked: true,
      protected: true,
      pageTitle: 'Failed reply details',
      props: true,
      breadcrumb: [
        {
          text: 'Failed reply details',
          active: true,
        },
      ],
    },
  },
]
